module.exports = __webpack_public_path__ + "img/clip_image105.77634a19.png";